import { withBreakpointObserver } from '@studiometa/js-toolkit';

import {
  Slider as SliderCore,
  SliderDots,
  SliderDrag,
  SliderItem,
  SliderBtn,
} from '@studiometa/ui';

/**
 * Slider component
 * @param  {Class} SliderCore
 * @returns {void}
 */
export default class Slider extends withBreakpointObserver(SliderCore) {
  static config = {
    components: {
      SliderDots,
      SliderDrag,
      SliderItem,
      SliderBtn,
    },
    options: {
      ...SliderCore.config.options,
      initialIndex: Number,
    },
  };

  /**
   * Change index when mounted
   * @returns {void}
   */
  mounted() {
    this.currentIndex = this.$options.initialIndex;
    super.mounted();
  }
}
